import { createBrowserRouter, Navigate } from 'react-router-dom';
import DashboardLayout from '../Layout/DashboardLayout';
import AuthLayout from '../Layout/AuthLayout';
import Dashboard from '../pages/Dashboard/Dashboard';
import InvoiceUpload from "../pages/InvoiceUpload/InvoiceUpload"
import Deals from "../pages/Deals/Deals"
import Settlement from "../pages/Settlement/Settlement"
import Reports from "../pages/Reports/Reports"
import Wallet from "../pages/Wallet/Wallet"
import Support from "../pages/Support/Support"
import Notifications from "../pages/Notifications/Notifications"
import Login from '../pages/Login/Login';
import NotFound from '../pages/Error/NotFound';
import Signup from '../pages/Signup/Signup';
import ForgotPassword from '../pages/Login/ForgotPassword';
import Otp from '../pages/Login/Otp';
import ChangePassword from '../pages/Login/ChangePassword';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import ErrorUI from '../pages/Error/ErrorUI';
import UploadFiles from '../pages/InvoiceUpload/Components/UploadFiles';
import SupplyChainUpload from "../pages/SupplyChainUpload/SupplyChainUpload";
import SupplyChainUploadFiles from '../pages/SupplyChainUpload/Components/UploadFiles';
import Profile from '../pages/Profile/Profile';
import DealDetailView from '../pages/Deals/Components/DealDetailView';
import PdfViewer from '../components/CustomPdfViewer/PdfViewer'
import QuestionBank from '../pages/QuestionBank/QuestionBank';
import EnrollAs from '../pages/Signup/EnrollAs';
import DealRequest from '../pages/DealRequest/DealRequest';
import DealManagement from '../pages/DealManagement/DealManagement';
import ForceChangePassword from '../pages/Login/ForceChangePassword';
import Sla from '../pages/Sla/Sla';
import Nda from '../pages/Nda/Nda';
import CompleteKyc from '../pages/CompleteKyc/CompleteKyc';
import CreditLimit from '../pages/CreditLimit/CreditLimit';
import Supplier from '../pages/Supplier/Supplier';
import SupplierDetails from '../pages/Supplier/SupplierDetails';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="login" />,
    },
    {
        path: '/',
        element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
        errorElement: <ErrorUI />,
        children: [
            { path: 'dashboard', element: <Dashboard /> },
            { path: 'credit-limit', element: <CreditLimit /> },
            { path: 'suppliers', element: <Supplier /> },
            { path: 'supplier', element: <Navigate to="/suppliers" replace /> },
            { path: 'suppliers/supplier-details/:supplierId/:status', element: <SupplierDetails /> },
            { path: 'invoice-upload', element: <InvoiceUpload /> },
            { path: 'upload-inv-files', element: <UploadFiles /> },
            { path: 'supply-chain-upload', element: <SupplyChainUpload /> },
            { path: 'upload-supply-chain-files', element: <SupplyChainUploadFiles /> },
            { path: 'deals', element: <Deals /> },
            { path: 'dealDetailView', element: <DealDetailView /> },
            { path: 'settlement', element: <Settlement /> },
            { path: 'reports', element: <Reports /> },
            { path: 'wallet', element: <Wallet /> },
            { path: 'support', element: <Support /> },
            { path: 'notifications', element: <Notifications /> },
            { path: 'Profile', element: <Profile /> },
            { path: 'profile', element: <Profile /> },
            { path: '/view-pdf/:pdfName', element: <PdfViewer /> },
            { path: 'questionnaire', element: <QuestionBank /> },
            { path: 'complete-kyc', element: <CompleteKyc /> },
            { path: 'sla', element: <Sla /> },
            { path: 'nda', element: <Nda /> },
            { path: 'deal-request', element: <DealRequest /> },
            { path: 'deal-management', element: <DealManagement/> }
        ],
    },
    {
        path: '/',
        element: <PublicRoute><AuthLayout /></PublicRoute>,
        errorElement: <ErrorUI />,
        children: [
            { path: 'login', element: <Login /> },
            { path: 'enroll-as', element: <EnrollAs /> },
            { path: 'signup', element: <Signup /> },
        ],
    },
    {
        path: 'forgot-password',
        element: <PublicRoute><ForgotPassword /></PublicRoute>,
        errorElement: <ErrorUI />,
    },
    {
        path: 'otp',
        element: <PublicRoute><Otp /></PublicRoute>,
        errorElement: <ErrorUI />,
    },
    {
        path: 'change-password',
        element: <PublicRoute><ChangePassword /></PublicRoute>,
        errorElement: <ErrorUI />,
    },
    {
        path: 'force-change-password',
        element: <ProtectedRoute><ForceChangePassword /></ProtectedRoute>,
        errorElement: <ErrorUI />,
    },
    {
        path: '*',
        element: <NotFound />,
    },
], {
    future: {
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_relativeSplatPath: true,
        v7_skipActionErrorRevalidation: true,
        v7_startTransition: true,
    }
});

export default router;
